<template>
  <div class="wrap">

    <div class="container-fluid">
      <div class="intro">
        <h2 class="intro-subtitle">Documentation E-Commerce</h2>
        <h1 class="intro-title">Intégration des produits via un fichier Excel</h1>
      </div>


      <div class="search">
        <form id="search">
          <div class="form-group">
            <input class="form-control" v-model="filter" placeholder="Chercher parmi les titres">
          </div>
        </form>
      </div>

      <div class="content">
        <table>
          <thead>
            <tr>
              <th v-for="key in tableHeader">{{ key }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="key in filteredData">
              <td>{{ key['title'] }}</td>
              <td>{{ key['description'] }}</td>
              <td>{{ key['example'] }}</td>
            </tr>
          </tbody>
        </table>

        <div class="extras">
          <h3>Autre</h3>
          <p>On peut ajouter les colonnes qu’on veut, donc si jamais on a des champs personnalisés à ajouter, on peut le faire.</p>

          <h3>Version EN/FR</h3>
          <p>Pour pouvoir la version bilingue, je suggère de faire une langue au complet et ensuite de dupliquer l'onglet du fichier excel une fois terminé. On doit s’assurer que les colonnes "fit" correctement, tel que le ID, group ID, etc.</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'table',
  data () {
    return {
      filter: '',
      tableHeader: ['Titre', 'Description', 'Exemple'],
      tableBody: [
        { title: 'ID', description: 'Nombre unique qui s’incrémente d’un produit à l’autre. Il est important car il permet de lié un produit FR au même produit EN.', example: '1' },
        { title: 'Group ID', description: 'Le group ID est un peu différent du ID. Il permet de lié un produit variable ensemble, donc un produit variable (qui est représenté sur plusieurs lignes par ses variations), doit avoir le même group ID.', example: '10001' },
        { title: 'SKU', description: 'Le SKU est le numéro qui représente le produit. En général, un SKU est unique pour chaque produit, voir même chaque variation (dans le cas d\'un produit variable). Le SKU peut contenir des lettres et des chiffres.', example: 'UTF-0001a' },
        { title: 'Product name', description: 'Le titre du produit.', example: 'Chemise noir d\'été' },
        { title: 'Status', description: '"publish" ou "draft". Publish pour définir qu’un produit est visible publiquement. Draft pour définir qu\'un produit existe dans l\'admin, mais qu\'il est caché du public. On se sert du status draft souvent lorsque le produit n\'est pas complété ou qu\'il n\'est plus disponible.', example: 'publish' },
        { title: 'Type', description: '"simple" ou "variable". Un produit simple est un produit qui n\' pas de variation de prix ou d\'attributs. Exemple: un livre. Un produit variable, à l\'inverse, est un produit avec différents modèles. Il peu avoir différentes grandeurs, couleurs, matériaux, etc. Par exemple, pour les vêtements. On peut avoir un chandail en bleu, vert ou rouge. Prendre note qu\'un produit variable est toujours représenté par plusieurs lignes du fichier excel. C\'est pourquoi il faut le regrouper avec le Group ID. Le titre, les catégories, les tags, la description et l\'excerpt doivent être le même pour chaque variation.', example: 'variable' },
        { title: 'Categories', description: 'Un produit peut être associé à plusieurs catégories. Pour créer une catégorie, simplement ajouter le nom dans cette colonne. Un séparateur ">" permet de définir qu’il y a une sous-catégorie. On peut avoir plusieurs catégories pour un même produit. Il faut séparer les catégories avec une pipe "|".', example: 'Vêtements>Chemises>Estival ou Vêtements>Chemises>Estival|Mode>Complet' },
        { title: 'Tags', description: 'Le tags permet de classer encore plus précisement un produit. Dans la même optique que les catégories, on peut avoir plusieurs tags. Le séparateur piep "|" permet de définir plusieurs tags.', example: 'Homme|Coton|Estival' },
        { title: 'Att color', description: 'Un attribut est utilisé uniquement pour les produits variables. Ça permet de définir les différents modèle du produit. Dans ce cas ci, c\'est la couleur qui est utilisé pour l\'attribut. On va donc avoir plusieurs rangées du fichier excel avec le même produit, mais qui contient une valeur différente dans cette colonne.', example: 'Noir' },
        { title: 'Price', description: 'Le prix du produit', example: '50' },
        { title: 'Sale price', description: 'Le prix en rabais du produit.', example: '40' },
        { title: 'Weight', description: 'Le poids en livres ou kilogrammes. Utilisé pour la livraison. Ne pas indiquer l\'unité de mesure.', example: '3' },
        { title: 'Length', description: 'La longeur du produit en millimètres ou en centimètres. Utilisé pour la livraison. Ne pas indiquer l\'unité de mesure.', example: '25' },
        { title: 'Width', description: 'La largeur du produit en millimètres ou en centimètres. Utilisé pour la livraison. Ne pas indiquer l\'unité de mesure.', example: '1' },
        { title: 'Height', description: 'La hauteur du produit en millimètres ou en centimètres. Utilisé pour la livraison. Ne pas indiquer l\'unité de mesure.', example: '15' },
        { title: 'Image', description: 'L\'image du produit est affiché à plusieurs endroit dans le site. Elle est tout d\'abord affichée en petit dans la page Hub (page qui liste les produits) ainsi que dans la page du produit en soit. Le séparateur pipe "|" permet d’avoir plusieurs images pour un produit. Prendre note que la première image va être l\'image à la une (image qui représente le produit dans la page hub). Il faut s\'assurer que le titre de l\'image est exactement le même à celui écrit ici dans le fichier excel. Attention à la nomenclature, il ne doit pas avoir d\'espace, de caractères spéciaux ou d\'accents dans les noms d\'images. On suggère de sauvegarder les images en .jpg.', example: 'P3F-Chemise-estivale-noir.jpg|P3F-Chemise-estivale-rouge.jpg' },
        { title: 'Product description', description: 'La description va être affiché sur la page single (page du produit en soit). Je conseille de rédiger le contenu dans un document word et de le copier coller dans le document excel pour garder les retours à la ligne. La description dans le fichier excel ne gère pas les bullets list et autre éléments visuels. Il va falloir faire une manipulation sur l’admin de WP de façon manuelle. Il n\'y a pas de limite de caractères.', example: 'Une chemise est un vêtement qui couvre le buste et les bras. Elle comprend un col, des manches longues et un boutonnage sur le devant.' },
        { title: 'Excerpt', description: 'Description courte du produit. En général la description courte est affichée dans la page hub (page qui liste tous les produits).', example: 'Une chemise est un vêtement qui couvre le buste et les bras.' },
        { title: 'PDF', description: 'Permet d’ajouter un PDF à la page single. Le champ est facultatif, donc s’il n’y a pas de texte à cet endroit, le PDF va être caché sur le site.', example: 'P3F-chemise-estivale.pdf' }
      ]
    }
  },
  computed: {
    filteredData: function () {
      var tableBody = this.tableBody.filter((row) => {
        return row.title.toLowerCase().includes(this.filter.toLowerCase())
      })
      return tableBody
    }
  }
}
</script>


<style lang="scss">
  @import '../../node_modules/bootstrap/scss/bootstrap.scss';
  @import '../main.scss';
  @import './table.scss';
</style>


// WEBPACK FOOTER //
// src/components/Table.vue